import { Outlet } from 'react-router-dom';
import useAccountStore from 'store/accountStore';
import CompetitionsPageNotAllowed from 'components/pages/Competitions/CompetitionsPageNotAllowed'; // Replace with your actual component

const CompetitionProtectedRoute = () => {
  const isTeam = useAccountStore((state) => state.activeAccount?.teamId);

  return isTeam ? <CompetitionsPageNotAllowed /> : <Outlet />;
};

export default CompetitionProtectedRoute;
